import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import * as styles from './index.vanilla.css'

export const EmptyStateLayout = ({ children }: React.PropsWithChildren) => {
  const animationRef = React.useRef<HTMLDivElement | null>(null)
  useUnsafeEffect(() => {
    setTimeout(
      () =>
        animationRef.current
          ? (animationRef.current.className = `${animationRef.current.className.replace(
              styles.initialOpacity,
              ''
            )} ${styles.transition}`)
          : null,
      100
    )
  }, [])

  return (
    <Box
      width="full"
      alignItems="center"
      gap="s80"
      className={styles.initialOpacity}
      ref={animationRef}
    >
      {children}
    </Box>
  )
}
